import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {
  Wrapper,
  Info,
  Contact,
  LocateUs,
  CallUs,
  Address,
  Phone,
  Logo,
  LogoText,
  HeaderStyled,
  SpecialHeader,
  NavStyled,
  DropdownMenu,
  OfflineMenuLinkStyled,
  ArrowDown,
  ArrowUp,
  LinkDropdownStyled,
  LinkHeaderStyled,
  LogoLink,
  Content
} from './Header.style';
import {sanitizeUrl} from '../../helpers/string.helper';

export class Header extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOfflineMenusDropdownMenuOpen: false
    };
    this.handleOfflineMenusDropdownMenuOpen = this.handleOfflineMenusDropdownMenuOpen.bind(this);
    this.handleOfflineMenusDropdownMenuClose = this.handleOfflineMenusDropdownMenuClose.bind(this);
  }
  handleOfflineMenusDropdownMenuOpen(e) {
    e.preventDefault();
    this.setState({isOfflineMenusDropdownMenuOpen: !this.state.isOfflineMenusDropdownMenuOpen});
  }

  handleOfflineMenusDropdownMenuClose() {
    setTimeout(function() {
      this.setState({isOfflineMenusDropdownMenuOpen: false});
    }.bind(this), 200);
  }

  render() {
    const {
      modes,
      extraInfo,
      logoUrl,
      restaurantName,
      address,
      tel,
      specialHeader,
      headerColor,
      showGalleryPage,
      showReviewPage,
      offlineMenus,
      externalWebsiteUrl,
      navigationMenu,
      navUrls
    } = this.props;
    const telephone = `tel:${tel}`;
    const googleMapsUrl = `https://www.google.co.uk/maps/place/${address}`;
    const renderBooking = modes.tableBooking &&
      <LinkHeaderStyled
        to={navUrls.bookingUrl}
        activeClassName="active"
        data-rw="navigation--table-booking-page-link"
      >
        <FormattedMessage id="header.nav.booking" />
      </LinkHeaderStyled>;
    const renderGallery = showGalleryPage &&
      <LinkHeaderStyled
        to={navUrls.galleryUrl}
        activeClassName="active"
        data-rw="navigation--gallery-page-link"
      >
        {navigationMenu ? navigationMenu.gallery : <FormattedMessage id="header.nav.gallery" />}
      </LinkHeaderStyled>;

    const renderReviews = showReviewPage &&
      <LinkHeaderStyled
        to={navUrls.reviewsUrl}
        activeClassName="active"
        data-rw="navigation--reviews-page-link"
      >
        {navigationMenu ? navigationMenu.reviews : <FormattedMessage id="header.nav.reviews" />}
      </LinkHeaderStyled>;

    const renderOfflineMenusDropdownMenu = this.state.isOfflineMenusDropdownMenuOpen &&
      <DropdownMenu>
        {
          offlineMenus.map(offlineMenu =>
            <li key={offlineMenu.id}>
              <LinkDropdownStyled
                to={`/offlineMenu/${offlineMenu.id}`}
                activeClassName="active"
                data-rw="navigation--offline-menu-link"
              >
                {offlineMenu.name}
              </LinkDropdownStyled>
            </li>
          )
        }
      </DropdownMenu>;

    const arrow = this.state.isOfflineMenusDropdownMenuOpen ? <ArrowUp /> : <ArrowDown />;

    const renderOfflineMenus = offlineMenus && offlineMenus.length > 0 &&
      <OfflineMenuLinkStyled
        onBlur={this.handleOfflineMenusDropdownMenuClose}
        onClick={this.handleOfflineMenusDropdownMenuOpen}
      >
        <LinkHeaderStyled
          to="#"
          activeClassName="active"
          data-rw="navigation--open-offline-menus-page-link"
        >
          <FormattedMessage id="header.nav.offlineMenus" />
          {arrow}
        </LinkHeaderStyled>
        {renderOfflineMenusDropdownMenu}
      </OfflineMenuLinkStyled>;

    const renderLogo = logoUrl ?
    (
      <Logo
        src={`${logoUrl}=s240`}
        alt={restaurantName}
        data-rw="home-page--about-us--restaurant-logo"
      />
    ) : <LogoText>{restaurantName}</LogoText>;

    const renderAddOnSiteHeader = !specialHeader && externalWebsiteUrl &&
      <LogoLink href={sanitizeUrl(externalWebsiteUrl)}>
        <Logo
          src={`${logoUrl}=s240`}
          alt={restaurantName}
          data-rw="home-page--about-us--restaurant-logo"
          isAddOnSite={true}
        />
      </LogoLink>;

    const renderExtraInfo = extraInfo && !externalWebsiteUrl &&
      <Info>
        <Contact>
          <LocateUs>
            <a
              href={googleMapsUrl}
              target="_blank"
              data-rw="header--location-link"
            >Locate us</a>
          </LocateUs>
          <Address data-rw="header--restaurant-address">{address}</Address>
          <CallUs>
            <a href={telephone}>Call us</a>
          </CallUs>
          <Phone data-rw="header--restaurant-telephone">{tel}</Phone>
        </Contact>
        {renderLogo}
      </Info>;

    const renderHeader = !specialHeader && !externalWebsiteUrl &&
      <HeaderStyled>
        <NavStyled>
          <LinkHeaderStyled
            to={navUrls.homeUrl}
            exact
            activeClassName="active"
            data-rw="navigation--home-page-link"
          >
            {navigationMenu ? navigationMenu.aboutUs : <FormattedMessage id="header.nav.home" />}
          </LinkHeaderStyled>
          <LinkHeaderStyled
            to={navUrls.menuUrl}
            activeClassName="active"
            data-rw="navigation--menu-page-link"
          >
            {navigationMenu ? navigationMenu.orderOnline : <FormattedMessage id="header.nav.order" />}
          </LinkHeaderStyled>
          {renderOfflineMenus}
          {renderBooking}
          {renderGallery}
          {renderReviews}
          <LinkHeaderStyled
            to={navUrls.contactUrl}
            activeClassName="active"
            data-rw="navigation--contact-page-link"
          >
            {navigationMenu ? navigationMenu.contactUs : <FormattedMessage id="header.nav.contact" />}
          </LinkHeaderStyled>
        </NavStyled>
      </HeaderStyled>;

    const renderSpecialHeader = specialHeader && <SpecialHeader headerColor={headerColor} />;

    return (
      <Wrapper
        class="restaurant-header"
        extraInfo={extraInfo}
      >
        <Content>
          {renderAddOnSiteHeader}
          {renderExtraInfo}
          {renderHeader}
          {renderSpecialHeader}
        </Content>
      </Wrapper>
    );
  }
}

Header.propTypes = {
  modes: PropTypes.object.isRequired,
  extraInfo: PropTypes.bool.isRequired,
  logoUrl: PropTypes.string,
  restaurantName: PropTypes.string,
  address: PropTypes.string,
  tel: PropTypes.string,
  specialHeader: PropTypes.bool.isRequired,
  headerColor: PropTypes.string.isRequired,
  showGalleryPage: PropTypes.bool.isRequired,
  offlineMenus: PropTypes.array.isRequired,
  externalWebsiteUrl: PropTypes.string,
  navigationMenu: PropTypes.object,
  showReviewPage: PropTypes.bool.isRequired,
  navUrls: PropTypes.object
};

Header.defaultProps = {
  providers: false
};

export default Header;



// WEBPACK FOOTER //
// ./containers/Header/Header.js